import React, { Component } from 'react';
import axios from 'axios';

import { formatDate, SubmitButton, TextBox } from '../../../Components/InputElements';
import PageTitle from "../../../Components/PageTitle";
import { ConfigContext } from '../../../Context/ConfigContext';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx'
import Select from 'react-select';
import { NoRecords } from '../../../Components/Shimmer';
import withRouter from '../../../Utils/withRouter';
import { decodeData,currentDateAndTime, getFullYearMonthArray } from '../../../Constants/constants';

class TeamsLeavesSandBox extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            employee_id: 0,
            employee_leave_id: 0,
            leave_type_id: 0,
            rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            keyword: "",
            from_date: "",
            to_date: "",
            selectOption: "",
            loadingFilter:false,
            month: parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[1]),
            monthOptions: [],
            employee_leave_status: '',
            leave_type_rows: [],
            reportrows: [],
            log_rows: [],
            selectedRows: [],
            filter_leave_type_id: '',
            checkAll: false,
            decodedData: [],
        };
        this.modalRef = React.createRef();
        this.closeRef = React.createRef();
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetLeaveTypeList();
        });
        let date = currentDateAndTime();
        let monthOpt = getFullYearMonthArray(date);
        this.setState({ monthOptions: monthOpt });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
            }
            } else {
            console.warn("Permissions not yet available. Retrying...");
            }
        }
    }
    GetLeaveLogs = (employee_leave_id, employee_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Approver/GetLeaveLogSandBox`, { params: { employee_leave_id: employee_leave_id, employee_id: employee_id, }, headers }).then((response) => {
            var data = response.data;
            this.setState({ log_rows: [] });
            if (response.data.success === true) {
                this.setState({
                    log_rows: data.data,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    GetLeaveInfo = (employee_leave_id, employee_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        this.setState({ log_rows: [], });
        axios.get(`${apiURL}Approver/GetLeaveInfoSandBox`, {
            params: {
                employee_leave_id: employee_leave_id,
                employee_id: employee_id,
            },
            headers,
        }).then((response) => {
            var data = response.data;
            if (data.success === true && this.state.log_rows.length === 0) {
                this.setState({
                    reportrows: data.data[0],
                    loadingList: false,
                });
                this.GetLeaveLogs(employee_leave_id);
            } else {
                this.setState({ loadingList: false });
            }
        });
    };

    // handleCheckboxChange = (employeeId, employeeLeaveId) => {
    //     this.setState((prevState) => {
    //         const selectedRows = [...prevState.selectedRows];
    //         const index = selectedRows.findIndex(row => row.employee_id === employeeId && row.employee_leave_id === employeeLeaveId);

    //         if (index > -1) {
    //             selectedRows.splice(index, 1);
    //         } else {
    //             selectedRows.push({ employee_id: employeeId, employee_leave_id: employeeLeaveId });
    //         }
    //         console.log(`selectedRows`, selectedRows);
    //         return { selectedRows };
    //     });
    // };

    handleCheckboxChange = (employeeLeaveId) => {
        this.setState((prevState) => {
            // Copy the previous selectedRows state
            const selectedRows = [...prevState.selectedRows];

            // Find the index of the employeeLeaveId in the selectedRows array
            const index = selectedRows.findIndex(row => row === employeeLeaveId);

            // If the id exists, remove it; otherwise, add it
            if (index > -1) {
                selectedRows.splice(index, 1);
            } else {
                selectedRows.push(employeeLeaveId);
            }

            // Return the updated selectedRows state
            return { selectedRows };
        }, () => {
            // Callback after setState to access the updated state
            console.log("Updated selectedRows: ", this.state.selectedRows);
        });
    };
    handleSelectAllCheckboxChange = (isChecked) => {
        if (isChecked) {
            this.setState((prevState) => {
                const selectedRows = prevState.rows
                    .filter(row => row.employee_leave_status === 0)
                    .map(row => (row.employee_leave_id));
                return { selectedRows, checkAll: true };
            }, () => {
                // Callback after setState to access updated state
                console.log("Updated selectedRows: ", this.state.selectedRows);
            });
        } else {
            this.setState({ selectedRows: [], checkAll: false }, () => {
                // Callback after setState to access updated state
                console.log("Updated selectedRows: ", this.state.selectedRows);
            });
        }
    };


    GetLeaveTypeList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetLeaveTypeListSandbox`, {params: { date: currentDateAndTime(), typelist: 0 }, headers })
            .then((response) => {
                var data = response.data;

                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        leave_type_rows: data.data.map((row) => ({
                            value: row.leave_type_id,
                            label: row.leave_type_name
                        }))
                    }));
                }
            });
    }

    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        axios.get(`${apiURL}Approver/GetPendingLeavesSandBox`, {
            params: {
                limit: this.state.limit,
                page: this.state.page,
                keyword: this.state.keyword,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                employee_leave_status: this.state.selectOption,
                leave_type_id: this.state.filter_leave_type_id,
                month: this.state.month,
                date: currentDateAndTime(),
            },
            headers,
        })
            .then((response) => {

                var data = response.data;
                if (response.data.success === true) {
                    this.setState({
                        rows: data.data,
                        next: data.next,
                        prev: data.prev,
                        page: data.page,
                        total_records: data.total_records,
                        total_pages: data.total_pages,
                        loadingList: false,
                        loadingFilter:false 
                    });
                }  
            }).catch((error) => {
                console.log(error);
                this.setState({
                    loadingList: false,
                    loadingFilter:false
                });
                Swal.fire({ 
                    title: `<strong>Failed</strong>`, 
                    text: 'Opps...! Something went wrong.', 
                    icon: 'error', 
                    showConfirmButton: true,
                    allowOutsideClick:false, 
                });
                 
            }) 
    };

    LeaveAction = (employee_id, employee_leave_id, accept_reject) => {
        Swal.fire({
            title: 'Submit Remark',
            input: 'text',
            inputPlaceholder: 'Enter your Remark',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            cancelButtonText: 'Cancel',
            // inputValidator: (value) => {
            //     if (!value) {
            //         return 'Remark cannot be empty';
            //     }
            // },
        }).then((result) => {
            if (result.isConfirmed) {
                var formData = {
                    employee_leave_status: accept_reject,
                };

                if (this.state.selectedRows.length !== 0) {
                    formData.employee_leave_id = JSON.stringify(this.state.selectedRows);
                    formData.type = "bulk";
                } else {
                    formData.employee_leave_id = employee_leave_id;
                    // formData.employee_id = employee_id;
                }

                if (result.value) {
                    formData.remark = result.value;
                } else {
                    formData.remark = '';
                }
                const { apiURL, apiHeaderJSON } = this.context;
                const headers = apiHeaderJSON;

                axios.post(`${apiURL}Approver/LeaveActionSandBox`, formData, { headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.message}</strong>`,
                            icon: response.data.success === true ? 'success' : 'error',
                        });
                        this.setState({ selectedRows: [] });
                        this.GetList();
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            }
        });
    };

    handleExcelDownload = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        axios.get(`${apiURL}Approver/GetPendingLeavesSandBox`, {
            params: {
                limit: this.state.total_records,
                page: 1,
                keyword: this.state.keyword,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                employee_leave_status: this.state.selectOption,
                leave_type_id: this.state.filter_leave_type_id,
            },
            headers,
        }).then((response) => {
            if (response.data.success === true) {
                const rows = response.data.data;

                console.log("rows", rows);
                const data = rows.map(row => ({
                    'Employee Code': row.employee_code,
                    'Employee Name': row.employee_name,
                    'Leave Type': row.heads_labels[0].concatenated_data,
                    'From Date': formatDate(row.employee_leave_from_date),
                    'To Date': formatDate(row.employee_leave_to_date),
                    'Before Balance': row?.employee_leave_balance_before,
                    'Duration': row.employee_leave_days + (row.employee_leave_days <= 1 ? " day" : " days"),
                    'After Balance': row?.employee_leave_balance_after,
                    'Status': row.employee_leave_status_label,
                }));


                const columns = [
                    { header: 'Employee Code', key: 'Employee Code', width: 20 },
                    { header: 'Employee Name', key: 'Employee Name', width: 30 },
                    { header: 'Leave Type', key: 'Leave Type', width: 15 },
                    { header: 'From Date', key: 'From Date', width: 20 },
                    { header: 'To Date', key: 'To Date', width: 20 },
                    { header: 'Before Balance', key: 'Before Balance', width: 15 },
                    { header: 'Duration', key: 'Duration', width: 10 },
                    { header: 'After Balance', key: 'After Balance', width: 15 },
                    { header: 'Status', key: 'Status', width: 15 },
                ];


                const wb = XLSX.utils.book_new();


                const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });


                ws['!cols'] = columns.map(column => ({ wch: column.width }));


                XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });


                columns.forEach((column, index) => {
                    ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
                });


                XLSX.utils.book_append_sheet(wb, ws, 'Team Leaves Report');
                

                XLSX.writeFile(wb, 'Team Leaves Report.xlsx');


                Swal.close();


                Swal.fire({
                    title: '<strong>Success</strong>',
                    html: 'Your file has been downloaded successfully.',
                    icon: 'success'
                });
            } else {

                Swal.close();

                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: response.data.message,
                    icon: 'error'
                });
            }
        })
            .catch((error) => {
                // Close the Swal alert if there is an error
                Swal.close();

                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error'
                });
            });
    }

    resetForm = () => {
        this.setState({
            employee_leave_id: 0,
            leave_type_id: '',
            employee_id: '',
            employee_leave_from_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            employee_leave_reason: '',
            employee_leave_to_day_unit: '',
            employee_leave_from_day_unit: '',
            fileName: "",
            fileSize: "",
        });
    }


    resetemployee_leave_document = () => {
        // Clear the input value
        const employee_leave_document = document.getElementById("employee_leave_document");
        if (employee_leave_document) {
            employee_leave_document.value = null;
        }
        // Keep the same key for the input
        let randomString = Math.random().toString(36);
        this.setState({
            theInputKey: randomString,
        });
    };

    handleInputSearch = (e) => {
        this.GetList();
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSelectChange = (name, selectedOption) => {
        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };


    handlePrev = (ev) => {
        if (this.state.prev === true) {
            this.setState(
                (prevState) => {
                    return { page: prevState.page - 1 };
                },
                () => {
                    this.GetList();
                }
            );
        }
    };
    handleNext = () => {
        if (this.state.next === true) {
            this.setState(
                (prevState) => {
                    return { page: prevState.page + 1 };
                },
                () => {
                    this.GetList();
                }
            );
        }
    };
    handleChange = (e) => {
        this.setState(
            (prevState) => {
                return { page: parseInt(e.target.value, 10) };
            },
            () => {
                this.GetList();
            }
        );
    };

    handleSelectStatus = (selectedOption) => {

        this.setState({ selectOption: selectedOption.value, });
    };

    handleSelectType = (selectedOption) => {
        this.setState({ filter_leave_type_id: selectedOption.value, });
    };

    handleClearAll = () => {
        this.setState(
            {
                filter_leave_type_id: '',
                // rows: [],
                next: false,
                prev: false,
                page: 1,
                limit: 10,
                total_records: 0,
                total_pages: 0,
                loadingList: false,
                keyword: "",
                from_date: "",
                to_date: "",
                selectOption: "",
                month: new Date()?.getMonth(),
            },
            () => {
                this.GetList();
            }
        );
    };

    handleLimitChange = (e) => {
        this.setState(
            {
                limit: parseInt(e.target.value, 10),
                page: 1,
            },
            () => {
                this.GetList();
            }
        );
    };

    render() {
        const { reportrows, log_rows, } = this.state;
        const limitOptions = [10, 25, 50, 100, 200, 500, this.state.total_records];
        const options = [
            { value: '0', label: 'Pending' },
            { value: '2', label: 'Approved' },
            { value: '1', label: 'Rejected' },
            { value: '3', label: 'Cancelled' },
        ];


        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? '#007bff' : '#fff',
                color: state.isSelected ? '#fff' : '#333',
                // padding: 10,
                ':hover': {
                    backgroundColor: '#007bff',
                    color: '#FFF',
                },
            }),
        };

        return (

            this.state.loadingList === false ?
                (<div className="main-content">
                    <div className='page-content'>
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Team leaves`} primary={`Team Employees`} path={`/TeamEmployees`}/>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row">
                                                <div className='col-md-3'>
                                                    <label htmlFor="keyword">Employee Name</label>
                                                    <div className="input-group">
                                                        <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search Name" />
                                                        <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                                                </div>
                                                <div className='col-md-3'>
                                                    <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                                                </div>
                                                {/* <div className='col-md-2 '>
                                                    <div className='position-relative'>
                                                        <div>
                                                            <label>Month</label>
                                                        </div>
                                                        <div style={{ "zIndex": 10, "width": "100%" }} className=' position-absolute'>
                                                            <Select
                                                                options={this.state.monthOptions}
                                                                value={this.state.month ? this.state.monthOptions.find(option => option.value === this.state.month) : null}
                                                                onChange={(selectOption) => this.setState({ month: selectOption?.value })}
                                                                hint={`Select Month`}
                                                            />
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className='col-md-3 position-relative mb-5'>
                                                    <div><label>Status</label></div>
                                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                                        <Select onChange={this.handleSelectStatus}
                                                            options={options}
                                                            placeholder={`Select Status`}
                                                            value={this.state.selectOption ? options.find(option => option.value === this.state.selectOption) : null}
                                                            styles={customStyles}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-3 position-relative mb-5'>
                                                    <div><label>Leave Type</label></div>
                                                    <div style={{ "zIndex": 9, "width": "90%" }} className=' position-absolute'>
                                                        <Select onChange={this.handleSelectType}
                                                        options={this.state.leave_type_rows}
                                                        placeholder={`Select Leave Type`}
                                                        value={this.state.filter_leave_type_id ? this.state.leave_type_rows.find((option) => option.value === this.state.filter_leave_type_id) : null} />
                                                    </div>
                                                </div>
                                                {/* <div className='col-md-6'>
                                                    <div className="row"> */}
                                                <div className='col-lg-2 col-md-3 col-6 '>
                                                    <div><label>Apply Filter</label></div>
                                                    {/* {this.state.loadingFilter === '1' ?
                                                        <button className="btn btn-info btn-load">
                                                        <span className="d-flex align-items-center">
                                                            <span className="spinner-border flex-shrink-0" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </span>
                                                            <span className="flex-grow-1 ms-2">
                                                            Loading...
                                                            </span>
                                                        </span>
                                                        </button>
                                                        :
                                                        <button
                                                        type="button"
                                                        onClick={()=>{
                                                         
                                                            this.setState({
                                                                loadingFilter:'1'
                                                            }, ()=> {this.handleInputSearch()
                                                            });

                                                        }}
                                                        className={`w-100 btn btn-info btn-label waves-effect waves-light ${(!this.state.keyword && this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}>
                                                        <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                        Filter
                                                        </button>
                                                    } */}
                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "1"},()=>{this.handleInputSearch()})}} 
                                                    disabled={!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption && !this.state.filter_leave_type_id}
                                                    loading={this.state.loadingFilter==="1"} loadingMessage='Loading' 
                                                    buttonName={"Filter"}  type='info' icon='ri-filter-3-fill' />
                                                   
                                                    
                                                </div>
                                                <div className='col-lg-2 col-md-3 col-6 '>
                                                    <div><label>Clear Filter</label></div>
                                                    {/* {this.state.loadingFilter === '2'? 
                                                    <button className="btn btn-secondary btn-load">
                                                    <span className="d-flex align-items-center">
                                                        <span className="spinner-border flex-shrink-0" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </span>
                                                        <span className="flex-grow-1 ms-2">
                                                        Loading...
                                                        </span>
                                                    </span>
                                                    </button>
                                                    :
                                                    <button
                                                    type="button"
                                                    className={`btn w-100 noWrap btn-secondary btn-label waves-effect waves-light ${(!this.state.keyword && this.state.from_date === '' && this.state.selectOption === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}
                                                    onClick={()=> {
                                                        this.setState({  loadingFilter:'2'},
                                                            ()=> {this.handleClearAll()
                                                            }
                                                        )
                                                        }}
                                                    >
                                                    <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 noWrap"></i> Clear</button>
                                                    }   */}
                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "2"},()=>{this.handleClearAll()})}} 
                                                    disabled={!this.state.keyword && !this.state.from_date && !this.state.selectOption && !this.state.to_date && !this.state.filter_leave_type_id}
                                                    loading={this.state.loadingFilter==="2"} loadingMessage='Loading'
                                                    buttonName={"Clear"}  type='secondary' icon='ri-database-2-line' />

                                                </div>
                                                {this.state.decodedData?.includes(6) && (
                                                <div className='col-lg-2 col-md-3 col-6 '>
                                                    <div><label>Export Excel</label></div>
                                                    {/* <button
                                                        type="button"
                                                        onClick={this.handleExcelDownload}
                                                        className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-success btn-label waves-effect waves-light noWrap`}>
                                                        <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                        Export Excel
                                                    </button> */}
                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.handleExcelDownload() }} 
                                                    disabled={this.state.rows.length === 0}
                                                    buttonName={"Export Excel"}  type='success' icon='ri-file-excel-2-line' />
                                                </div>)}
                                                {/* </div>
                                                </div> */}
                                            </div>
                                                {this.state.selectedRows.length !== 0 ?
                                                    (
                                                    // <div className='col-md-3'>
                                                        <div className="row">
                                                            <>
                                                                <div className='col-lg-2 col-md-3 col-6 '>
                                                                    <div><label>Approve leave</label></div>
                                                                    {/* <button
                                                                        type="button"
                                                                        onClick={() => this.LeaveAction(0, 0, 2)}
                                                                        className={`btn btn-success btn-label waves-effect waves-light `}>
                                                                        <i className="bx bx-check-circle label-icon align-middle fs-20 me-2"></i>
                                                                        Approve
                                                                    </button> */}
                                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={(e) => this.LeaveAction(0, 0, 2)} 
                                                                    buttonName={"Approve"}  type='success' icon='bx bx-check-circle' />
                                                                </div>
                                                                <div className='col-lg-2 col-md-3 col-6 '>
                                                                    <div><label>Reject Leave</label></div>
                                                                    {/* <button
                                                                        type="button"
                                                                        className={`btn btn-danger btn-label waves-effect waves-light`}
                                                                        onClick={() => this.LeaveAction(0, 0, 1)}
                                                                    >
                                                                        <i className="bx bx-x-circle label-icon align-middle fs-20 me-2"></i>
                                                                        Reject
                                                                    </button> */}
                                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={(e) => this.LeaveAction(0, 0, 1)} 
                                                                    buttonName={"Reject"}  type='danger' icon='bx bx-x-circle' />
                                                                </div>
                                                            </>
                                                        </div>
                                                    // </div>
                                                    ) : ""
                                                }

                                        </div>
                                        {/* className={`table table-bordered table-hover`} */}
                                        <div className="card-body">
                                            <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }} className="table-responsive-lg">
                                                <table style={{ minwidth: '100%' }} className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped" >
                                                    <thead className='bg-primary text-light bg-gradient position-sticky top-0 z-1'>
                                                        <tr className='text-center'>
                                                            <th className=' noWrap'>Select
                                                                <div className="d-flex justify-content-center align-items-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        className={` form-check-input`}
                                                                        checked={this.state.selectedRows?.length >= 1 && this.state.checkAll}
                                                                        onChange={(e) => this.handleSelectAllCheckboxChange(e.target.checked)}
                                                                        disabled={this.state?.rows?.length < 1}
                                                                    />
                                                                </div>
                                                            </th>
                                                            <th className=' noWrap'>Employee Code</th>
                                                            <th className=' noWrap'>Employee Name</th>
                                                            <th className=' noWrap'>Leave Type</th>
                                                            <th className=' noWrap'>From Date</th>
                                                            <th className=' noWrap'>To Date</th>
                                                            <th className=' noWrap'>Before Balance</th>
                                                            <th className=' noWrap'>Leaves Days</th>
                                                            <th className=' noWrap'>After Balance</th>
                                                            <th className=' noWrap'>Leaves Status </th>
                                                            {this.state.decodedData?.includes(1) && (
                                                            <th className=' noWrap'>Leaves Details </th>
                                                            )}
                                                                {this.state.decodedData?.includes(3) && (
                                                            <th width="100" className="text-center">Action</th>
                                                                )}
                                                        </tr>
                                                    </thead>

                                                    {this.state.rows.length === 0 ? (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={11}>
                                                                    <NoRecords />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    ) :
                                                        <tbody>
                                                            {this.state.rows.map((row) => {
                                                                return (
                                                                    <tr key={row.employee_leave_id}>
                                                                        <td >
                                                                            <div className="d-flex justify-content-center align-items-center">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className={`${row.employee_leave_status === 0 ? "" : `disabled bg-${row?.employee_leave_status_class}`} form-check-input`}
                                                                                    checked={this.state.selectedRows.some(selectedRow => selectedRow === row.employee_leave_id)}
                                                                                    onChange={() => row.employee_leave_status === 0 && this.handleCheckboxChange(row.employee_leave_id)}
                                                                                    disabled={row.employee_leave_status !== 0}
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                        <td className=' noWrap'>{row.employee_code}</td>
                                                                        <td>
                                                                            {row.employee_name}

                                                                        </td>
                                                                        <td className=' noWrap'>{row.heads_labels[0].concatenated_data}</td>
                                                                        <td className=' noWrap'>{formatDate(row.employee_leave_from_date)}</td>
                                                                        <td className=' noWrap'>{formatDate(row.employee_leave_to_date)}</td>
                                                                        <td>{row?.employee_leave_balance_before || "--"}</td>
                                                                        <td>{row.employee_leave_days} <span>Days</span></td>
                                                                        <td>{row?.employee_leave_balance_after || "--"}</td>
                                                                        <td className='text-center'><span className={`badge bg-${row.employee_leave_status_class}`} >{row.employee_leave_status_label}</span></td>
                                                                        {this.state.decodedData?.includes(1) && (
                                                                        <td >
                                                                            <div className=" text-center" >
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-primary"
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#exampleModalPopovers"
                                                                                    onClick={() => this.GetLeaveInfo(row.employee_leave_id, row.employee_id)}
                                                                                >
                                                                                    {/* <i className="bx bx-message-alt-detail label-icon align-middle fs-16 me-2" /> */}
                                                                                    Details
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                        )}
                                                                        {this.state.decodedData?.includes(3) && (
                                                                        <td>

                                                                        
                                                                            <div className='d-flex justify-content-around gap-2'>
                                                                            {this.state.decodedData?.includes(3) && (
                                                                                <button
                                                                                    onClick={() => this.LeaveAction(row.employee_id, row.employee_leave_id, 2)}
                                                                                    type="button"
                                                                                    className={`${row.employee_leave_status === 0 && this.state.selectedRows.length === 0 ? ("") : "disabled"}  btn btn-success btn-sm`}
                                                                                >
                                                                                    {/* <i className="bx bx-check-circle label-icon align-middle fs-20 "></i> */}
                                                                                    Approve
                                                                                </button>)}

                                                                                <button
                                                                                    onClick={() => this.LeaveAction(row.employee_id, row.employee_leave_id, 1)}
                                                                                    type="button"
                                                                                    className={`${(row.employee_leave_status === 0 || row.employee_leave_status === 2)
                                                                                            && this.state.selectedRows.length === 0 ? ("") : "disabled"}  btn btn-danger btn-sm`}
                                                                                >
                                                                                    {/* <span
                                                                                    class="spinner-border flex-shrink-0"
                                                                                    role="status"
                                                                                    style={{
                                                                                    width: "0.8rem",
                                                                                    height: "0.8rem",
                                                                                    borderWidth: "2px",
                                                                                    }}
                                                                                >
                                                                                    <span class="visually-hidden">Loading...</span>
                                                                                </span> */}
                                                                                    {/* <i className="bx bx-x-circle label-icon align-middle fs-20 "></i> */}
                                                                                    Reject
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                    )}
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>}

                                                </table>
                                            </div>
                                            <div className="d-flex justify-content-between bg-light align-items-center flex-wrap w-100 py-2 px-2">
                                                {/* <button disabled={ this.state.prev === false && this.state.loadingList === false ? true : false }
                                                type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}>
                                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                    Previous
                                                </button> */}
                                                <SubmitButton onClick={()=>{ this.handlePrev() }} 
                                                disabled={this.state.prev === false && this.state.loadingList === false}
                                                buttonName={"Previous"}  type='warning' icon='ri-arrow-left-line' />
                                                <SubmitButton otherClasses='d-md-none d-block' iconSide='right' onClick={()=>{ this.handleNext() }} 
                                                disabled={this.state.next === false && this.state.loadingList === false}
                                                buttonName={"Next"}  type='primary' icon='ri-arrow-right-line' />
                                                <div className="col-md-4 col-12 my-md-0 my-2" style={{ display: "flex", alignItems: "center" }}>
                                                    {
                                                        <small>
                                                            Total Records: {this.state.total_records} |
                                                            Total Pages: {this.state.total_pages} |
                                                            Current Page: {this.state.page}
                                                        </small>
                                                    }
                                                </div>
                                                <div className="col-md-2">
                                                    <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                        {Array.from(
                                                            { length: this.state.total_pages },
                                                            (_, i) => (
                                                                <option selected={this.state.page === i + 1} key={i} value={i + 1}>
                                                                    Page {i + 1}
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                                        {limitOptions.map((option) => (
                                                            <option key={option} value={option}>
                                                                Limit {option}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {/* <button disabled={ this.state.next === false && this.state.loadingList === false ? true : false }
                                                type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}>
                                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                    Next
                                                </button> */}
                                                <SubmitButton otherClasses='d-md-block d-none' iconSide='right' onClick={()=>{ this.handleNext() }} 
                                                disabled={this.state.next === false && this.state.loadingList === false}
                                                buttonName={"Next"}  type='primary' icon='ri-arrow-right-line' />
                                            </div>
                                            <div className="modal fade" id="exampleModalPopovers" tabIndex={-1} aria-labelledby="exampleModalPopoversLabel" aria-modal="true">
                                                <div className="modal-dialog modal-xl ">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title" id="exampleModalPopoversLabel">Employee Leave Details</h5>
                                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                                        </div>
                                                        <div className="modal-body">
                                                            <div class="card shadow-none">
                                                                <div class="card-header d-flex justify-content-between align-items-center">
                                                                    <h6 class="card-title mb-0">{reportrows.employee_name}</h6>
                                                                    {reportrows.leave_type_name &&
                                                                        <h6 class="card-title mb-0">
                                                                            {reportrows.leave_type_name}
                                                                        </h6>
                                                                    }
                                                                    <a href={`${reportrows.employee_leave_document_url}`}
                                                                        className={`${!reportrows.employee_leave_document_url ? ('d-none') : ''} link-info link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover`}
                                                                        style={{ marginTop: "10px", float: 'right' }}
                                                                        target="_blank" rel="noopener noreferrer">
                                                                        View Uploaded Document
                                                                    </a>
                                                                </div>
                                                                <div class="card-body">
                                                                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                                        <h6 class="">From :{formatDate(reportrows.employee_leave_from_date)}
                                                                            <div><span className="text-muted mt-2">{reportrows.employee_leave_from_day_unit}</span></div>
                                                                        </h6>
                                                                        <h6 class="">To :{formatDate(reportrows.employee_leave_to_date)}
                                                                            <div><span className="text-muted mt-2">{reportrows.employee_leave_to_day_unit}</span></div>
                                                                        </h6>
                                                                        <h6 class="">Total Leave days :{reportrows.employee_leave_days}</h6>
                                                                    </div>
                                                                </div>
                                                                <div class="card-footer d-flex justify-content-between align-items-center flex-wrap">
                                                                    <div className="">
                                                                        <span class="">Leave Reason</span>
                                                                        <p class="card-text text-muted mb-0">{reportrows.employee_leave_reason || "No Reason"}</p>
                                                                    </div>
                                                                    <span className={`badge bg-${reportrows.employee_leave_status_class}`}>{reportrows.employee_leave_status_label}</span>
                                                                </div>
                                                            </div>

                                                            <div className="my-3">
                                                                <h5 className="modal-title" id="exampleModalPopoversLabel">Employee Leave Logs</h5>
                                                            </div>
                                                            <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                                <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                                    <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                                                        <tr>
                                                                            <th className='noWrap'>Action Date</th>
                                                                            <th className='noWrap'>Action By</th>
                                                                            <th className='noWrap'>Leave Type</th>
                                                                            <th className='noWrap'>From Date</th>
                                                                            <th className='noWrap'>To Date</th>
                                                                            <th className='noWrap'>Total Leave Days</th>
                                                                            <th>Reason</th>
                                                                            <th>Remark</th>
                                                                            <th>Status</th>

                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {log_rows.map((row) => {
                                                                            var leave_obj = JSON.parse(row.leave_apply_object);
                                                                            return (
                                                                                <tr key={row.employee_leave_log_id}>
                                                                                    <td>{formatDate(row.created_date)}</td>
                                                                                    <td>{row.created_by_name}</td>
                                                                                    <td>{leave_obj.leave_name}</td>
                                                                                    <td>{formatDate(leave_obj.employee_leave_from_date)}</td>
                                                                                    <td>{formatDate(leave_obj.employee_leave_to_date)}</td>
                                                                                    <td>{leave_obj.employee_leave_days}</td>
                                                                                    <td className={`${leave_obj.employee_leave_reason?.length > 30 ? " textEllipse" : "noWrap"}`}>{leave_obj.employee_leave_reason || "--"}</td>
                                                                                    <td className={`${row.remark?.length > 30 ? " textEllipse" : "noWrap"}`}>{row.remark || "--"}</td>
                                                                                    <td ><span className={`badge bg-${row.employee_leave_log_status_class}`}>{row.employee_leave_status_label}</span></td>
                                                                                </tr>
                                                                            )
                                                                        })}

                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        <div className="modal-footer">
                                                            <button type="button" className="btn btn-light" data-bs-dismiss="modal">Close</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                ) : <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

        );
    }
}

export default withRouter(TeamsLeavesSandBox);